import { maxQtyInUnit } from './maxQtyInUnit';

/** @typedef {'issue' | 'transfer' | 'return'} UnitQtyFloatingLabelTone */

const TONE_MAX_VERB = {
  issue: '可出',
  transfer: '上限',
  return: '可退',
};

/**
 * FloatingInput 數量 label：本單位上限＋基本可用（出庫／轉倉／退料共用句型）。
 *
 * @param {object} params
 * @param {unknown} params.availableBase 基本單位可用量
 * @param {number} params.qtyMax 所選單位可輸入整數上限（0＝無上限文案）
 * @param {UnitQtyFloatingLabelTone} [params.tone='issue']
 * @returns {string}
 */
export function formatUnitQtyFloatingLabel({
  availableBase,
  qtyMax,
  tone = 'issue',
}) {
  const base = Number(availableBase);
  const baseDisplay = Number.isFinite(base) ? base : 0;
  const max = Number(qtyMax);
  const hasMax = Number.isFinite(max) && max > 0;
  const verb = TONE_MAX_VERB[tone] ?? TONE_MAX_VERB.issue;

  if (hasMax) {
    return `${verb} ${max}｜基本可用 ${baseDisplay}`;
  }
  return `基本可用 ${baseDisplay}`;
}

/**
 * 先算 maxQtyInUnit 再格式化 label。
 *
 * @param {unknown} availableBase
 * @param {Array<object>|null|undefined} unitOptions
 * @param {string} [unitId]
 * @param {UnitQtyFloatingLabelTone} [tone='issue']
 * @returns {string}
 */
export function formatUnitQtyFloatingLabelFromBounds(
  availableBase,
  unitOptions,
  unitId,
  tone = 'issue',
) {
  return formatUnitQtyFloatingLabel({
    availableBase,
    qtyMax: maxQtyInUnit(availableBase, unitOptions, unitId),
    tone,
  });
}
